function EGiftRecipient() {
    this.name = ''
    this.email = ''
    this.confirmEmail = ''
    this.message = ''
}

export default EGiftRecipient
